export default {
  area: "三门峡市智慧养老",
  objectName: "",
  //url
  // hostUrl : 'http://cuiyun.dexian.ren/',
  hostUrl: 'https://smxcity.anluoyun.cn',
  apiHttpsUrl: 'https://smxcity.anluoyun.cn/prod-api',
  apiRequestUrl: 'https://smxcity.anluoyun.cn/prod-api',
  apiUploadUrl: 'https://smxcity.anluoyun.cn/prod-api/upload/uploadImage',
  apiUploadFiles: 'https://smxcity.anluoyun.cn/prod-api/upload/uploadImage',
  apiRequestUrlOrgan: 'https://smxcity.anluoyun.cn/prod-api/So/',
}
